import { defineStore } from 'pinia'
import { reactive, ref } from 'vue'
// import liff from '@line/liff'

export const useCommonStore = defineStore('common', () => {
  const user = reactive({
    Cellphone: '',
    EventName: '',
    IsExist: null,
    register: null,
    member: null,
  })

  const loading = ref(true)
  const buttonDisabled = ref(false)

  const errorServer = reactive({
    open: false,
    title: '',
    message: '',
  })

  return {
    user,
    errorServer,
    loading,
    buttonDisabled,
  }
})
